import { Form, Formik } from "formik";
import { Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { CommonButton } from "components/UiElement";
import { Input as TextInput } from "../../../Antd";
import validation from "./validation";

export default function ManageSubscriptionForm({
  userModalHide,
  subscription,
  onSubmit,
  t,
}) {
  let initialValues = {
    name: subscription?.name || "",
    amount: subscription?.amount || "",
  };

  return (
    <>
      <Formik
        initialValues={{ ...initialValues }}
        onSubmit={(e) => onSubmit(e)}
        validationSchema={validation()}
        enableReinitialize
      >
        {(props) => {
          return (
            <Form>
              <Row className="gy-3">
                <Col sm="6">
                  <div className="form-group">
                    <label>
                      {t("text.adminManageSubscription.subscriptionName")}
                    </label>
                    <TextInput
                      id="name"
                      name="name"
                      className="form-control"
                      type="text"
                      placeholder={t(
                        "text.adminManageSubscription.subscriptionNamePlaceholder"
                      )}
                      setFieldValue={props.handleChange}
                    />
                  </div>
                </Col>
                <Col sm="6">
                  <div className="form-group">
                    <label>
                      {t("text.adminManageSubscription.subscriptionAmount")}
                    </label>
                    <TextInput
                      id="amount"
                      name="amount"
                      className="form-control"
                      type="text"
                      placeholder={t(
                        "text.adminManageSubscription.subscriptionAmountPlaceholder"
                      )}
                      setFieldValue={props.handleChange}
                    />
                  </div>
                </Col>
              </Row>
              <div className="d-flex align-items-center justify-content-end mt-3">
                <CommonButton className="btn btn-primary me-2" type="submit">
                  {t("text.common.update")}
                </CommonButton>

                <Link
                  href="#"
                  onClick={() => userModalHide()}
                  className="btn btn-outline-primary"
                >
                  {t("text.common.cancel")}
                </Link>
              </div>
            </Form>
          );
        }}
      </Formik>
    </>
  );
}
